/**
 * Types of entities in the game
 */
export var EntityType;
(function (EntityType) {
    EntityType["KING_SHEEP"] = "KING_SHEEP";
    EntityType["SHEEP"] = "SHEEP";
    EntityType["DOG"] = "DOG";
    EntityType["DACHSHUND"] = "DACHSHUND";
    EntityType["SHEPHERD_DOG"] = "SHEPHERD_DOG";
    EntityType["GOLDEN_DACHSHUND"] = "GOLDEN_DACHSHUND";
    EntityType["WOLF_PACK"] = "WOLF_PACK";
    EntityType["BLACK_SHEEP"] = "BLACK_SHEEP";
})(EntityType || (EntityType = {}));
/**
 * Types of tiles on the board
 */
export var TileType;
(function (TileType) {
    TileType["GRASS"] = "GRASS";
    TileType["MOUNTAIN"] = "MOUNTAIN";
    TileType["WATER"] = "WATER";
    TileType["PASTURE"] = "PASTURE";
    TileType["GOLD_MINE"] = "GOLD_MINE";
})(TileType || (TileType = {}));
/**
 * Types of resources
 */
export var ResourceType;
(function (ResourceType) {
    ResourceType["WOOL"] = "WOOL";
    ResourceType["GOLD"] = "GOLD";
})(ResourceType || (ResourceType = {}));
/**
 * Game phases
 */
export var GamePhase;
(function (GamePhase) {
    GamePhase["SETUP"] = "SETUP";
    GamePhase["PLACEMENT"] = "PLACEMENT";
    GamePhase["ROLL"] = "ROLL";
    GamePhase["RESOLUTION"] = "RESOLUTION";
    GamePhase["ENDED"] = "ENDED";
})(GamePhase || (GamePhase = {}));
/**
 * Types of player actions
 */
export var ActionType;
(function (ActionType) {
    ActionType["PLACE_KING_SHEEP"] = "PLACE_KING_SHEEP";
    ActionType["PLACE_SHEEP"] = "PLACE_SHEEP";
    ActionType["MOVE_SHEEP"] = "MOVE_SHEEP";
    ActionType["BUY_DOG"] = "BUY_DOG";
    ActionType["PLACE_DOG"] = "PLACE_DOG";
    ActionType["BUY_CARD"] = "BUY_CARD";
    ActionType["PLAY_CARD"] = "PLAY_CARD";
    ActionType["SELL_WOOL"] = "SELL_WOOL";
    ActionType["ROLL_DICE"] = "ROLL_DICE";
    ActionType["MOVE_BLACK_SHEEP"] = "MOVE_BLACK_SHEEP";
    ActionType["END_TURN"] = "END_TURN";
})(ActionType || (ActionType = {}));
/**
 * Types of cards
 */
export var CardType;
(function (CardType) {
    CardType["DOUBLE_PRICE"] = "DOUBLE_PRICE";
    CardType["MOVE_BLACK_SHEEP"] = "MOVE_BLACK_SHEEP";
    CardType["PAINT_BUCKET"] = "PAINT_BUCKET";
    CardType["WOLF_IN_SHEEPS_CLOTHING"] = "WOLF_IN_SHEEPS_CLOTHING";
    CardType["WOLF_PACK"] = "WOLF_PACK";
})(CardType || (CardType = {}));
/**
 * AI difficulty levels
 */
export var AIDifficulty;
(function (AIDifficulty) {
    AIDifficulty["EASY"] = "EASY";
    AIDifficulty["MEDIUM"] = "MEDIUM";
    AIDifficulty["HARD"] = "HARD";
})(AIDifficulty || (AIDifficulty = {}));
/**
 * Win condition types
 */
export var WinConditionType;
(function (WinConditionType) {
    WinConditionType["MOST_SHEEP"] = "MOST_SHEEP";
    WinConditionType["MOST_GOLD"] = "MOST_GOLD";
    WinConditionType["MOST_RESOURCES"] = "MOST_RESOURCES";
    WinConditionType["CUSTOM"] = "CUSTOM";
})(WinConditionType || (WinConditionType = {}));
/**
 * Player connection status
 */
export var PlayerStatus;
(function (PlayerStatus) {
    PlayerStatus["CONNECTED"] = "CONNECTED";
    PlayerStatus["DISCONNECTED"] = "DISCONNECTED";
    PlayerStatus["AWAY"] = "AWAY";
})(PlayerStatus || (PlayerStatus = {}));
//# sourceMappingURL=enums.js.map